// Angular
import { Component, ComponentFactoryResolver, OnDestroy  } from '@angular/core';
import { BroadcastService, ModalService, ModalSize, ToasterType } from '@cv-invision/core';
// AG-Grid
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { FNCCallCenterClientComponent } from '../call-center-clients-form/call-center-client-form';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FNCDefaultSettingService } from '../service/fnc-default-setting.service';
import { Store } from '@ngxs/store';
import { GlobalConfigurationState } from '../../../state/global-configuration.state';
import { SetFNCSettings } from '../../../state/actions/global-configuration.actions';
@Component({
	selector: 'cv-callcenter-fnc-custom-action',
	templateUrl: './custom-action-callcenter-fnc.components.html',
	styleUrls: ['./custom-action-callcenter-fnc.components.scss']
})
export class CustomActionCallCenterFNCCellComponent implements ICellRendererAngularComp, OnDestroy{
	public cellValue: any;
	private atComponentDestroy: Subject<any> = new Subject<any>();
	public recordIndex: number;
	constructor(
        private modalService: ModalService,
		private componentFactoryResolver: ComponentFactoryResolver,
		private FNCDefaultSettingService: FNCDefaultSettingService,
		private broadcastService: BroadcastService,
		private store: Store
	) {}

	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.recordIndex = params.rowIndex;
		this.cellValue = params.data;
	}

	/**
	 * edit client
	 */
	onEditClient(): void {
		this.modalService
			.open({
				componentFactoryResolver: this.componentFactoryResolver,
				component: FNCCallCenterClientComponent,
				data: {...this.cellValue, isEditing: true},
				modalConfiguration: {
					title: `Update Xpance client configuration`,
					modalSize: ModalSize.MD
				}
			})
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				if (result.success) {
					this.FNCDefaultSettingService.setFormData({ metadata:{reloadList: true} });
				}
			});
	}

    /**
	 * ondelete action client
	 */
	onDeleteClient(): void {
		this.modalService
			.customConfirm(
				'Do you want to delete this Client?',
				'If you delete this Client, all information related will be lost.',
				'icon-warning fas fa-exclamation-circle',
				'Delete Client',
				'cv-btn-link-error'
			)
			.subscribe(result => {
				if (result.confirm === 'confirm') {
					this.deleteClient();
				}
			});
	}

	/**
	 * delete client 
	 */
	deleteClient():void {
		const defaultSettings = JSON.parse(JSON.stringify(this.store.selectSnapshot(GlobalConfigurationState.getFNCSettings)));
		defaultSettings.clients.splice(this.recordIndex, 1);
		this.FNCDefaultSettingService
			.saveFNCDefaultSettings(defaultSettings)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(
				result => {
					if (result && result.succeeded) {
						this.broadcastService.broadcast({
							name: ToasterType.SUCCESS,
							event: { message: 'Client successfully deleted' }
						});
					}
					this.store.dispatch(new SetFNCSettings(defaultSettings));
					this.FNCDefaultSettingService.setFormData({ metadata:{reloadList:true} });
				},
				error => {
					console.error(error);
					this.broadcastService.broadcast({
						name: ToasterType.ERROR,
						event: { error: 'Error occurred ' + error }
					});
			}
		);
	}

	/**
	 * Put back the value
	 * @param params
	 */
	refresh(params: ICellRendererParams): boolean {
		this.cellValue = params;
		return true;
	}

	/**
	 * On component destroy
	 */
	 ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
